import accountRegister from '@/components/account/account-register/account-register.vue';
import accountRegisterFooter from '@/components/account/account-register/footer/footer.vue';
import heroUnitSlider from '@/components/landing-pages/hero-unit-slider/hero-unit-slider.vue';
import quotes from '@/components/home/home-old/quotes/quotes.vue';

export default {
  components: {
    accountRegister,
    accountRegisterFooter,
    heroUnitSlider,
    quotes,
  },
};




// WEBPACK FOOTER //
// ./src/components/landing-pages/index2/index2.js